import request from '@/utils/request'
let baseURL = '/im-api';
// 直播点卡管理

// 创建充值订单
export function liveCardOrder(data) {
  return request({
    url: '/LiveCard/v1/creatLiveCardOrder',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
amount (string): 充值数量，单位元 ,
beneficiaryUserOpenid (string): 订单受益人 ,
beneficiaryUserType (integer): 订单受益人类型，0-个人，1-店铺 , ++++++++
remark (string, optional): 备注 ,
userOpenid (string): 用户/店铺openid ,
userType (integer): 用户类型，0-个人，1-店铺 +++++++++
}
* */

// 获取用户直播点卡信息
export function getLiveCardInfo(data) {
  return request({
    url: '/LiveCard/v1/getLiveCardInfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
userOpenid (string): 用户openid ,
userType (integer): 用户类型，0-个人，1-店铺 +++++++++
}
* */


// 获取单个充值订单记录
export function liveCardOrderInfo(data) {
  return request({
    url: '/LiveCard/v1/getLiveCardOrderInfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
orderNo (string): 订单号
}
* */

// 获取直播点卡消费/充值记录（分页）
export function liveCardRecord(data) {
  return request({
    url: '/LiveCard/v1/getLiveCardRecord',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
userOpenid (string): 用户/店铺openid , +++++++++++++
userType (integer): 用户类型，0-个人，1-店铺 +++++++++++++++++
page (integer, optional),
size (integer, optional)
}
* */

